import { render } from "./ProduceHeader.vue?vue&type=template&id=71796d50&scoped=true"
import script from "./ProduceHeader.vue?vue&type=script&lang=js"
export * from "./ProduceHeader.vue?vue&type=script&lang=js"

import "./ProduceHeader.vue?vue&type=style&index=0&id=71796d50&scoped=true&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/wanfei-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71796d50"]])

export default __exports__